import { render, staticRenderFns } from "./ReportesSMS.vue?vue&type=template&id=36bc002e&"
import script from "./ReportesSMS.vue?vue&type=script&lang=ts&"
export * from "./ReportesSMS.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports